<template>
    <div class="vip-container">
        <div v-for="(item, index) in list" :key="index" class="vip-card">
            <div v-if="item.text" class="vip-tag" :style="{ backgroundColor: item.tagcolor || '#f54e00' }">
                {{ item.text }}
            </div>
            <div class="vip-card-body">
                <div>
                    <div class="vip-name">{{ item.vipinfo.name || '未命名' }}</div>
                    <div class="vip-expiry">{{ item.end_time }}</div>
                </div>
                <div class="vip-stats">
                    <div class="vip-stat-value">{{ item.yu }}</div>
                    <div class="vip-stat-value" style="font-size:16px;color:#807d72;">{{ item.today }}</div>
                </div>
            </div>
        </div>
        <div v-if="list.length === 0" class="no-vip">
            您还未开通会员
        </div>
    </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）

export default {
    name: '',
    components: {

    },
    // 定义属性
    data() {
        return {
            list: [],
            page: 1,
        }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {},
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {
        get_vip_list() {
            this.$ajax.post('qhy/user/user_vip_list?page=' + this.page, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(res => {
                console.log(res.data)
                var jg = res.data
                if (res.data.status == 200) {
                    if (jg.list.data.length == 0) {
                        this.$msg.warning('没有更多了')
                        this.status = 'nomore'
                    }
                    for (var i = 0; i < jg.list.data.length; i++) {
                        this.list.push(jg.list.data[i])
                    }
                    this.balance = jg.balance
                } else {
                    this.$msg.error(res.data.msg)
                }
            })

        },
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() { }, // 生命周期 - 创建之前
    beforeMount() { }, // 生命周期 - 挂载之前
    beforeUpdate() { }, // 生命周期 - 更新之前
    updated() { }, // 生命周期 - 更新之后
    beforeDestroy() { }, // 生命周期 - 销毁之前
    destroyed() { }, // 生命周期 - 销毁完成
    activated() { }, // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style scoped>
.vip-container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
}

.vip-card {
    position: relative;
    border: 1px solid #e6e5e0;
    border-radius: 10px;
    background: #ffffff;
    padding: 16px 18px;
}

.vip-tag {
    position: absolute;
    top: 0;
    left: 0;
    padding: 2px 10px;
    font-size: 11px;
    font-weight: 600;
    color: #fff;
    border-radius: 10px 0 10px 0;
}

.vip-card-body {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.vip-name {
    font-size: 15px;
    font-weight: 600;
    color: #26251e;
    margin-bottom: 3px;
}

.vip-expiry {
    font-size: 13px;
    color: #807d72;
}

.vip-stats {
    text-align: right;
    line-height: 1.6;
}

.vip-stat-value {
    font-size: 18px;
    font-weight: 500;
    color: #26251e;
}

.no-vip {
    grid-column: 1 / -1;
    text-align: center;
    padding: 40px 0;
    font-size: 14px;
    color: #a09c92;
}

@media (max-width: 800px) {
    .vip-container {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 480px) {
    .vip-container {
        grid-template-columns: 1fr;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/User/my/user_vip.vue


// WEBPACK FOOTER //
// src/components/User/my/user_vip.vue